ready(function(){

	// -- variables --
	const body = document.body;
	const mainMenuBtn = document.getElementById('mainMenuBtn');
	const learnMoreMenuBtn = document.getElementById('learnMoreMenuBtn');
	const closeLearnMoreMenuBtn = document.getElementById('closeLearnMoreMenu');
  const doc = document.documentElement;
	const header = document.getElementById('header');
	const main = document.getElementById('main');
	let prevScrollpos = window.pageYOffset;


	// -- open/close mainMenu --
	mainMenuBtn.addEventListener('click', function (e) {
		mainMenuBtn.classList.toggle('is-active');
		body.classList.toggle('mainMenuOpen');
	});


	// -- open/close learnMoreMenuOpen --
	learnMoreMenuBtn.addEventListener('click', function (e) {
		learnMoreMenuBtn.classList.toggle('is-active');
		body.classList.toggle('learnMoreMenuOpen');
	});
	closeLearnMoreMenuBtn.addEventListener('click', function (e) {
		learnMoreMenuBtn.classList.remove('is-active');
		body.classList.remove('learnMoreMenuOpen');
	});


	// -- reset active/open menu classes on resize --
	function resetActiveMenus(){
		mainMenuBtn.classList.remove('is-active');
		body.classList.remove('mainMenuOpen');
		learnMoreMenuBtn.classList.remove('is-active');
		body.classList.remove('learnMoreMenuOpen');
	}
	let resizeWindowTimeOut;
	window.onresize = function(){
	  clearTimeout(resizeWindowTimeOut);
	  resizeWindowTimeOut = setTimeout(resetActiveMenus, 100);
	};


	// -- hide header on scroll down & show on scroll up --
	["load", "resize"].forEach(function (e) {
	  window.addEventListener(e, function(){
		  doc.style.setProperty('--header-height', `${header.offsetHeight}px`);
	  });
	});	
	window.onscroll = function() {
	  let currentScrollPos = window.pageYOffset;
	  if (prevScrollpos > currentScrollPos || currentScrollPos <= 0) {
	    header.style.top = 0;
	  } else {
	    header.style.top = `-${header.offsetHeight}px`;
	    closeDropdown();
	  }
	  prevScrollpos = currentScrollPos;
	}

});